<template>
<div class="fixed-navbar">
      <div class="app-content content container-fluid" ><!--style="padding-top: 4rem"-->
        <div class="content-wrapper">
          <router-view />
          <!-- <chat></chat> -->
        </div>
      </div>
</div> 
</template>

<script>
// import chat from '../components/chat';

    export default {
        name: "content-container",
        components: {
          // chat
        },
        data() {
            return {}
        },
        mounted() {
        },
        created() {
        },
        methods: {
        }
    };
</script>

<style>
  
    
</style>



// WEBPACK FOOTER //
// src/pages/Content.vue